// Peak-normalized PCM waveform extractor used by voice-note UIs.
// Runs entirely offline via a single-shot AudioContext.decodeAudioData
// — no realtime analyser, so a failed decode never blocks the send.
// Returns 40 floats in [0..1]; empty array on failure so the caller
// can gracefully fall back to a flat/placeholder bar row.
export const WAVEFORM_BARS = 40;

export async function computeWaveformFromBlob(blob) {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx || !blob) return [];
    const buf = await blob.arrayBuffer();
    const ctx = new Ctx();
    const decoded = await new Promise((resolve, reject) => {
      try {
        const p = ctx.decodeAudioData(buf.slice(0), resolve, reject);
        if (p && typeof p.then === "function") p.then(resolve, reject);
      } catch (e) {
        reject(e);
      }
    });
    const data = decoded.getChannelData(0);
    const total = data.length;
    if (!total) return [];
    const bucket = Math.max(1, Math.floor(total / WAVEFORM_BARS));
    const bars = new Array(WAVEFORM_BARS).fill(0);
    for (let i = 0; i < WAVEFORM_BARS; i++) {
      let peak = 0;
      const start = i * bucket;
      const end = Math.min(total, start + bucket);
      for (let j = start; j < end; j++) {
        const v = Math.abs(data[j]);
        if (v > peak) peak = v;
      }
      bars[i] = peak;
    }
    const max = bars.reduce((a, b) => Math.max(a, b), 0);
    if (max <= 0) return bars;
    return bars.map((b) => Math.min(1, b / max));
  } catch (e) {
    console.warn("waveform compute failed", e);
    return [];
  }
}
